import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/async-creatable';
import { ReactSelectInput } from '..';
const ReactSelectAsyncCreatableInputComponent = (_a, ref) => {
    var { cacheOptions = true, defaultOptions = true, selectComponent = AsyncCreatableSelect, variant = 'normal' } = _a, props = __rest(_a, ["cacheOptions", "defaultOptions", "selectComponent", "variant"]);
    return (_jsx(ReactSelectInput, Object.assign({ cacheOptions: cacheOptions, defaultOptions: defaultOptions, selectComponent: selectComponent, variant: variant }, props, { ref: ref })));
};
export const ReactSelectAsyncCreatableInput = forwardRef(ReactSelectAsyncCreatableInputComponent);
const ReactSelectAsyncInputComponent = (_a, ref) => {
    var { cacheOptions = true, defaultOptions = true, selectComponent = AsyncSelect, variant = 'normal' } = _a, props = __rest(_a, ["cacheOptions", "defaultOptions", "selectComponent", "variant"]);
    return (_jsx(ReactSelectInput, Object.assign({ cacheOptions: cacheOptions, defaultOptions: defaultOptions, selectComponent: selectComponent, variant: variant }, props, { ref: ref })));
};
export const ReactSelectAsyncInput = forwardRef(ReactSelectAsyncInputComponent);
//# sourceMappingURL=index.js.map